export enum UnsubscribePage {
  title = 'unsubscribePage.title',
  subtitle = 'unsubscribePage.subtitle',
  description = 'unsubscribePage.description',
  warning = 'unsubscribePage.warning',
  helpTxt = 'unsubscribePage.helpTxt',
  footer = 'unsubscribePage.footer',
  submit = 'unsubscribePage.submit',
}
